export const USER_CHANGE = 'USER_CHANGE';

export const setUser = ({id}) => async dispatch => {
  dispatch({ type: USER_CHANGE, payload: {id} });
};


// WEBPACK FOOTER //
// ./src/actions/user.js